import { useTranslation } from 'react-i18next';

import { Constants } from '../Constants';
import { ModalWithTracking } from '../ModalWithTracking/ModalWithTracking';

type CallModalProps = {
  title?: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  children: React.ReactNode;
  callButtonRef?: React.RefObject<HTMLElement>;
};

export const CallModal = ({
  title,
  isOpen,
  setIsOpen,
  callButtonRef,
  children,
}: CallModalProps) => {
  const { t } = useTranslation();
  return (
    <ModalWithTracking
      analyticsInfo={{
        linkName: title ?? 'Call Modal',
        modalName: title ?? 'Call Modal',
        location: `body:call-modal`,
      }}
      data-auto-testid="call-modal"
      data-testid="call-modal"
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
        if (callButtonRef?.current) {
          setTimeout(() => {
            callButtonRef?.current?.focus();
          }, 0);
        }
      }}
      title={`${t('Call')}`}
      trackingType={Constants.ADOBE_TRACKING.MODAL_WITH_LINK_TRACKING}
    >
      {children}
    </ModalWithTracking>
  );
};
